export enum DeliveryNoteDocumentTypes {
  Outgoing,
  Incoming
}
